// extracted by mini-css-extract-plugin
export default {"checkbox":"GOsieUtKgOEcA6oHXmHv","checkmark":"Fu3C4qFDBcKWT59butEh"};